import { useInView } from "react-intersection-observer";

const lembaga = [
	{
		icon: "🕌",
		title: "Masjid",
		desc: "Menjadikan masjid pusat peradaban — digital, ekonomi, dan spiritual yang aktif melayani jamaah.",
	},
	{
		icon: "🏢",
		title: "Yayasan Keislaman",
		desc: "Penguatan kapasitas yayasan melalui program wakaf produktif, distribusi Al-Qur'an, dan ekonomi kreatif.",
	},
	{
		icon: "📚",
		title: "Pesantren",
		desc: "Mendukung kemandirian ekonomi santri dan lembaga melalui peternakan, halal, dan ekosistem digital.",
	},
	{
		icon: "💛",
		title: "LAZ / ZISWAF",
		desc: "Transparansi pengelolaan ZISWAF, wakaf produktif peternakan, dan pemberdayaan mustahiq menjadi muzakki.",
	},
	{
		icon: "🤝",
		title: "Komunitas Dakwah",
		desc: "Program pemberdayaan komunitas melalui edukasi bisnis islami, konten dakwah digital, dan jaringan reseller NusaQu.",
	},
	{
		icon: "✨",
		title: "Lembaga Anda?",
		desc: "Hubungi kami — tim NusaQu siap merancang program pemberdayaan yang sesuai kebutuhan spesifik lembaga Anda.",
		special: true,
	},
];

function TCard({ item, delay }) {
	const { ref, inView } = useInView({ threshold: 0.1, triggerOnce: true });
	return (
		<div
			ref={ref}
			style={{
				...styles.card,
				...(item.special ? styles.cardSpecial : {}),
				opacity: inView ? 1 : 0,
				transform: inView ? "translateY(0)" : "translateY(28px)",
				transition: `opacity 0.6s ${delay}s, transform 0.6s ${delay}s`,
			}}
			onMouseEnter={(e) => {
				e.currentTarget.style.transform = "translateY(-5px)";
				e.currentTarget.style.boxShadow = "0 16px 38px rgba(123,63,0,.12)";
				if (!item.special)
					e.currentTarget.querySelector(".bar").style.transform = "scaleX(1)";
			}}
			onMouseLeave={(e) => {
				e.currentTarget.style.transform = "translateY(0)";
				e.currentTarget.style.boxShadow = "none";
				if (!item.special)
					e.currentTarget.querySelector(".bar").style.transform = "scaleX(0)";
			}}>
			{!item.special && <div className="bar" style={styles.bar} />}
			<div style={styles.icon}>{item.icon}</div>
			<h3 style={item.special ? styles.titleSpecial : styles.title}>
				{item.title}
			</h3>
			<p style={item.special ? styles.descSpecial : styles.desc}>{item.desc}</p>
		</div>
	);
}

export default function TargetLembaga() {
	const { ref, inView } = useInView({ threshold: 0.1, triggerOnce: true });
	return (
		<section id="target" style={styles.section}>
			<div
				ref={ref}
				style={{
					textAlign: "center",
					marginBottom: "3rem",
					opacity: inView ? 1 : 0,
					transform: inView ? "translateY(0)" : "translateY(20px)",
					transition: "all 0.6s",
				}}>
				<div style={{ marginBottom: "0.8rem" }}>
					<span style={styles.lbl}>Target Lembaga</span>
				</div>
				<h2 style={styles.h2}>Siapa yang Dapat Bergabung?</h2>
				<p style={styles.sub}>
					MASQUDE terbuka untuk semua lembaga keislaman di Indonesia yang ingin
					bertumbuh bersama ekosistem NusaQu
				</p>
			</div>
			<div className="grid-3col" style={styles.grid}>
				{lembaga.map((item, i) => (
					<TCard key={item.title} item={item} delay={i * 0.1} />
				))}
			</div>
		</section>
	);
}

const styles = {
	section: { background: "var(--bg)", padding: "6rem 5%" },
	lbl: {
		display: "inline-block",
		background: "var(--coklat)",
		color: "var(--kuning2)",
		padding: "0.28rem 0.95rem",
		borderRadius: "2rem",
		fontSize: "0.72rem",
		fontWeight: 800,
		letterSpacing: "3px",
		textTransform: "uppercase",
	},
	h2: {
		fontFamily: "Lora, serif",
		fontSize: "clamp(1.7rem, 3.5vw, 2.7rem)",
		fontWeight: 700,
		color: "var(--coklat)",
		marginBottom: "0.8rem",
	},
	sub: {
		color: "var(--abu)",
		fontSize: "0.97rem",
		maxWidth: "600px",
		margin: "0 auto",
	},
	grid: {
		gap: "1.2rem",
		maxWidth: "1000px",
		margin: "0 auto",
	},
	card: {
		background: "white",
		border: "1.5px solid rgba(123,63,0,.1)",
		borderRadius: "14px",
		padding: "1.8rem 1.4rem",
		textAlign: "center",
		transition: "all 0.3s",
		position: "relative",
		overflow: "hidden",
		cursor: "default",
	},
	cardSpecial: {
		background: "var(--coklat)",
		borderColor: "var(--coklat)",
	},
	bar: {
		position: "absolute",
		bottom: 0,
		left: 0,
		right: 0,
		height: "3px",
		background: "linear-gradient(90deg, var(--coklat), var(--kuning))",
		transform: "scaleX(0)",
		transition: "transform 0.3s",
		transformOrigin: "left",
	},
	icon: { fontSize: "2.4rem", marginBottom: "0.9rem" },
	title: {
		fontWeight: 700,
		fontSize: "1.02rem",
		color: "var(--coklat)",
		marginBottom: "0.4rem",
	},
	titleSpecial: {
		fontWeight: 700,
		fontSize: "1.02rem",
		color: "var(--kuning2)",
		marginBottom: "0.4rem",
	},
	desc: { fontSize: "0.83rem", color: "var(--abu)", lineHeight: 1.6 },
	descSpecial: {
		fontSize: "0.83rem",
		color: "rgba(255,255,255,.78)",
		lineHeight: 1.6,
	},
};
